import { createContext } from 'react';

import type { NewClientsListContextInterface } from '@pages/Clients/NewClientsList/context/NewClientsListContext.types';

type Nullable<T> = T | null;

export const NewClientsListContext =
  createContext<Nullable<NewClientsListContextInterface>>(null);
